import React from 'react';
import ChromeCastPlayer from '../../components/Player/ChromeCastPlayer';
import { useCast } from '../hooks/use-cast';
import { assertsCastRequired } from '../utils/assert';

export function CastDetector() {
  const cast = useCast();

  if (cast.sessionStatus !== 'connected' || cast.mediaStatus === 'pending') {
    return null;
  }

  assertsCastRequired(cast);

  return <ChromeCastPlayer cast={cast} />;
}
